import { render, staticRenderFns } from "./ContentComposer.vue?vue&type=template&id=685446e4&scoped=true&"
import script from "./ContentComposer.vue?vue&type=script&lang=ts&"
export * from "./ContentComposer.vue?vue&type=script&lang=ts&"
import style0 from "./ContentComposer.vue?vue&type=style&index=0&id=685446e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685446e4",
  null
  
)

export default component.exports